import * as Yup from "yup";

export const verificationCodeSchema = Yup.object().shape({
    code:Yup.number().min(4).required("Code is required")
});
